import {
  BookingSolutionServiceRS,
  DerivedPriceModel,
  FileDto,
  FiltroTipoCameraTariffe,
  RouteInfo,
  ViewUbicazioneIstat,
} from './dto';
import {
  CalcoloPrezzoPacchetto,
  CampoFiltroWorkFlow,
  CategoriaServizio,
  CondizioneCampoFiltroWorkFlow,
  EnteRilascioDocumento,
  FlagPreventivo,
  FonteRecensione,
  GiornoSettimana,
  HtmlElement,
  ImportoPayMail,
  LettereMaiuscole,
  MealPlanType,
  MittenteMessaggio,
  ModalitaCalcoloPrezzo,
  ModalitaModificaDisponibilitaXPortaleXAlbergo,
  ModalitaSceltaMenuMySelf,
  ModalitaSelezioneTariffaWorkFlowCreazionePreventivo,
  ModelloAutomatismo,
  ModelloPrezzo,
  Pagina,
  PaginaMessaggioCliente,
  PercentualeSchermoWelcomeDashboard,
  Ruolo,
  SecureSocketOptions,
  Sesso,
  SslProtocols,
  StatoContabilizzazione,
  StatoCtaCtd,
  StatoEsecuzioneTransazione,
  StatoPortaleXAlbergo,
  StatoPrenotazione,
  StatoPrenotazioneWelcome,
  StatoPreventivo,
  StatoPubblicazionePortale,
  StatoRoomingList,
  StatoSondaggio,
  StatoUpSelling,
  StelleAlbergo,
  TestoMyPage,
  TipoAnagrafica,
  TipoAnalytics,
  TipoApiKey,
  TipoApplicazionePromozione,
  TipoApplicazioneSupplemento,
  TipoArrotondamento,
  TipoArticolo,
  TipoBilanciamentoInterno,
  TipoBloccoHtml,
  TipoCartaCredito,
  TipoCausaleOperazione,
  TipoCodicePromozione,
  TipoComponentePrenotazione,
  TipoContabilizzazione,
  TipoDatoWelcomeDashboard,
  TipoDettaglioProposta,
  TipoDisponibilitaArticolo,
  TipoDocumento,
  TipoDomandaSondaggio,
  TipoErroreLogAccesso,
  TipoErroreLogPortale,
  TipoEsitoOperazionePortaleXAlbergo,
  TipoGrafico,
  TipoInvioEmail,
  TipoListino,
  TipoLogAccesso,
  TipologiaAlbergo,
  TipoLogSBM,
  TipoModalitaPagamento,
  TipoModificaDisponibilitaXPortaleXAlbergo,
  TipoModificaStatoPortaliCollegati,
  TipoNotificaEmail,
  TipoOperazionePortaleXAlbergo,
  TipoOperazioneWebHooks,
  TipoOrdinamentoRichiestePreventivi,
  TipoOrdinamentoTariffe,
  TipoPaginaDms,
  TipoPaginaMySelf,
  TipoParametroPortale,
  TipoParametroRicerca,
  TipoPasto,
  TipoPenaleCancellazione,
  TipoPermesso,
  TipoPortale,
  TipoPrenotazione,
  TipoPrenotazioneExtra,
  TipoPrenotazioneXPay,
  TipoProduzioneXComponenteXPrenotazione,
  TipoPromozione,
  TipoPubblicazioneDisponibilitaWelcomeWS,
  TipoRichiestaPreventivo,
  TipoRisorsa,
  TipoScontoProposta,
  TipoServizio,
  TipoSupplemento,
  TipoTemplate,
  TipoValore,
  TipoValoreWelcomeDashboard,
  TipoVisualizzazioneBanner,
  TipoVisualizzazioneGrigliaDisponibilita,
  TipoVisualizzazioneImmagine,
  TipoVisualizzazioneImmaginePrenotazione,
  TipoVisualizzazioneTariffe,
  TipoWorkFlow,
  ValiditaOffertaPeriodo,
  VersioneMyPage,
  VersioneSelfCheckIn,
} from './enum';

export class Base {
  oid: number;
  isDeleted: boolean;
  dataCreazione: string;
  OIDHotel: number;

  constructor(oid?: number) {
    if (oid != null) {
      this.oid = oid;
    }
  }
}

export class BaseAlbergo extends Base {
  albergo: Albergo;
}

export class Albergo extends Base {
  nome: string;
  codice: number;
  utente: string;
  password: string;
  passwordMask: string;

  apiKey: string;

  isApplicaVariazionePrezzoBase: boolean;

  isRecaptchaAttiva: boolean;
  isVisualizzaBottoniSocialLoginStep2: boolean;
  isVisualizzaBottoneNuovaPrenotazioneUltimoStep: boolean;

  isInviaCopiaMailClienteAdAlbergo: boolean;

  aziendaHotel: string;
  codicePartner: string;

  urlWebBooking: string;

  dati: AlbergoDati;

  isAccettaPreventiviConPagamentoImmediato: boolean;
  isRimuoviProposteNonDisponibili: boolean;

  oidLingueAttive: string;

  versioneHotelCommerciale: string;
  dataUltimoAccessoPlanningWeb: string;
  dataUltimoAccessoBackgroundWorker: string;
  dataUltimoAggiornamentoPrenotazioni: string;
  dataUltimoAggiornamentoModuloWeb: string;
  tipoPubblicazioneAttivitaAutomatica: string;
  isBudgetConfigurato: boolean;
  dataScadenzaContratto: string;
  serverWelcome: string;
  codiceInstallazione: string;

  camereEffettive: number;

  tipoPortalePubblicazione: string;
  dataInizioPubblicazione: string;
  dataFinePubblicazione: string;
  isEseguiCalcoliDisponibilitaSuTipoCameraVendita: boolean;

  giorniScadenzaPreventivo: number;
  giorniScadenzaCaparraPreventivo: number;
  percentualeCaparraPreventivo: number;

  isRichiediPeriodoAperturaPlanningDisponibilita: boolean;
  isRaggruppaPlanningXTipoCamera: boolean;
  giorniDefaultPlanningDisponibilita: number;
  giorniDefaultPubblicaDisponibilita: number;

  urlMySelf: string;
  isTest: boolean;

  isAbilitaModificaCliente: boolean;
  isDisattivaVecchiaExtranet: boolean;

  isAccountBloccato: boolean;

  linguaDefaultClientePreventivo: Lingua;

  dimensioneFontPlanningDisponibilita: number;

  colorePlanningGiornoNonPubblicato: number;
  colorePlanningGiornoModificatoDaPubblicare: number;
  colorePlanningGiornoPubblicatoParzialmente: number;

  colorePlanningGiornoNonPubblicatoHex: string;
  colorePlanningGiornoModificatoDaPubblicareHex: string;
  colorePlanningGiornoPubblicatoParzialmenteHex: string;

  lettereMaiuscoleAnagrafica: LettereMaiuscole;

  isMySelfAttivo: boolean;
  isCrsAttivo: boolean;
  isPro: boolean;

  isAbilitaPreBooking: boolean;

  isCheckInSemplificato: boolean;
  isVerificaRecordModificatiWS: boolean;
  tipoPubblicazioneDisponibilitaWelcomeWS: TipoPubblicazioneDisponibilitaWelcomeWS;

  tipoLogSBM: TipoLogSBM;

  numeroRecordPubblicazioneAttivitaAutomatiche: number;

  tipoOrdinamentoRichieste: TipoOrdinamentoRichiestePreventivi;
  tipoOrdinamentoPreventivi: TipoOrdinamentoRichiestePreventivi;

  isVisualizzaTipoCameraTariffaCalcolaRetta: boolean;
  isVisualizzaFiltroServiziCalcolaRetta: boolean;

  isVisualizzaSelezioneClientePreventivoCalcolaRetta: boolean;

  urlApiWelcome: string;

  isControllaDisponibilitaWelcomeBooking: boolean;
  isRecuperaInformazioniPrenotazioneWelcomeSelfCheckIn: boolean;
  isControllaCamereLibereWelcomeBooking: boolean;
  isAggiornaFasceWelcome: boolean;
  isAggiornaFasciaPrezzoBaseWelcome: boolean;
  isAttivaSelezionaCameraPreventivo: boolean;
  isRecuperaAddebitiPrenotazioneWelcomeMySelf: boolean;
  isAggiornaClientiWelcome: boolean;
  isAggiornaPiattiWelcome: boolean;
  isImportaClientiRichiesteWelcome: boolean;
  isControllaQuantitaMassimaSupplementiWelcome: boolean;

  urlApiBeauty: string;
  usernameBeauty: string;
  passwordBeauty: string;
  isUsaBeautyVoucher: boolean;

  smtpServer: SmtpServer;

  constructor(oid?: number) {
    super(oid);
  }
}

export class AlbergoDati extends Base {
  numeroClientCC: number;
  numeroClientConnessi: number;
  dataUltimoAccessoPlanningWeb: string;
  dataUltimoAccessoBackgroundWorker: string;
  dataScadenzaContratto: string;
  tipoPortalePubblicazione: string;
  dataInizioPubblicazione: string;
  dataFinePubblicazione: string;
  isBudgetConfigurato: boolean;
  isEseguiCalcoliDisponibilitaSuTipoCameraVendita: boolean;
  tipoPubblicazioneAttivitaAutomatica: string;
  isPubblicazioneDisponibiliHotelAttiva: boolean;
  tipoProdotto: string;
  codiceInstallazione: string;
  versioneHotelCommerciale: string;
  isCrmAttivo: boolean;
  isDmsAttivo: boolean;
  isMySelfAttivo: boolean;
  isCrsAttivo: boolean;
  camereEffettive: number;
  isDemo: boolean;
  is3DSecureAttivo: boolean;
  serverWelcome: string;
  isDev: boolean;
  isPro: boolean;
}

export class Utente extends BaseAlbergo {
  descrizione: string;
  username: string;
  isAttivo: boolean;
  token: string;
  apiKey: string;
  codicePartner: string;
  ruolo: Ruolo;
  permessi: string[];
  plugins: RouteInfo[];
  urlImmagine: string;
  urlSmartCloud: string;
  isAutenticazioneADueFattoriAttiva: boolean;
  isVisualizzaSoloCamereDisponibili: boolean;
  isVisualizzaSoloTariffePrenotabili: boolean;
  isVisualizzaCamereConPaxNonValide: boolean;
  sezioniDashboardAbilitate: string;
  ubicazioneIstat: UbicazioneIstat;
}

export class UtenteXPermesso extends Base {
  tipoPermesso: TipoPermesso;
  utente: Utente;
}

export class VideoTutorial extends Base {
  nome: string;
  descrizione: string;
  ordinamento: number;
  isAttivo: boolean;
  route: string;
  url: string;
  urlImmagine: string;
  tags: string;
}

export class ParametroRicerca extends BaseAlbergo {
  codice: string;
  descrizione: string;
  ordinamento: number;
  colore: number;
  coloreHex: string;
  tipoParametro: TipoParametroRicerca;
  isAttivo: boolean;
  tagCrm: TagCrm;
  sondaggio: Sondaggio;
  motivoViaggio: MotivoViaggio;
}

export class ParametroRicercaXLingua extends Base {
  descrizione: string;
  lingua: Lingua;
  parametroRicerca: ParametroRicerca;
}

export class Cliente extends BaseAlbergo {
  nome: string;
  cognome: string;
  email: string;
  cellulare: string;
  ragioneSociale: string;
  lingua: Lingua;
  codiceLingua: string;
  provincia: string;
  indirizzo: string;
  citta: string;
  CAP: string;
  nazione: string;
  nazioneObject: Nazione;
  interessi: string;
  note: string;
  privacy: boolean;
  newsletter: boolean;
  blackList: boolean;
  mercato: ParametroRicerca;
  canaleVendita: ParametroRicerca;
  segmento: ParametroRicerca;
  fonte: ParametroRicerca;
  dataUltimaPrenotazione: string;
  dataUltimoPreventivo: string;
  dataUltimoSondaggio: string;
  password: string;
  passwordMask: string;
  tokenCC: string;
  tipologia: TipoCliente;
  isNotificaGestionale: boolean;
  dataNascita: string;
  dataModificaWelcome: string;
  tipoAnagrafica: TipoAnagrafica;
  sconto: number;
  codiceTessera: string;
  codiceFiscale: string;
  partitaIva: string;
  isEscludiDaAutomatismi: boolean;
  codiceDestinatario: string;
}

export class TipoCameraStandard extends BaseAlbergo {
  nome: string;
  descrizione: string;
  ordinamento: number;
}

export class TipoCamera extends BaseAlbergo {
  nome: string;
  sigla: string;
  descrizione: string;
  ordinamento: number;
  letti: number;
  paxMin: number;
  paxMax: number;
  enfantMax: number;
  enfantExtraPaxMax: number;
  isDisponibile: boolean;
  urlImmagine: string;
  tipoRisorsa: TipoRisorsa;
  tipoCameraStandard: TipoCameraStandard;
}

export class Lingua extends Base {
  nome: string;
  codice: string;
  flagIcon: string;
  cultureInfoName: string;
}

export class TipoCameraXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  tipoCamera: TipoCamera;
}

export class Articolo extends BaseAlbergo {
  nome: string;
  descrizione: string;
  urlImmagine: string;
  isDisponibile: boolean;
  ordinamento: number;
  quantitaMassimaInPrenotazione: number;
  isImportaComeExtraAutomatico: boolean;
  prezzo: number;
  tipoArticolo: TipoArticolo;
  isUpSellingCRM: boolean;
  voceAddebito: VoceAddebito;
  isBookingExtra: boolean;
  isNascondiSenzaPeriodoXListino: boolean;
  tipoRisorsa: TipoRisorsa;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  isRoomService: boolean;
  isCreaSupplementiExtraPreventivo: boolean;
  dataModificaWelcome: string;
  isAggiungiATutteLeProposte: boolean;
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  arrotondamento: Arrotondamento;
  oidTipiCameraRoomService: string;
}

export class Trattamento extends Articolo {
  totalePax: number;
  giorniSoggiorno: number;
  calcoloPrezzoPacchetto: CalcoloPrezzoPacchetto;
  tipoServizio: TipoServizio;
}

export class DettaglioTrattamento extends Base {
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  isIllimitato: boolean;
  quantita: number;
  data: string;
  importo: number;
  isPerPersona: boolean;
  percentuale: number;
  tipoDisponibilitaArticolo: TipoDisponibilitaArticolo;
  numeroGiorniMassimiTassaSoggiorno: number;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  importoMassimoTassaSoggiorno: number;
  tipoProduzioneXComponenteXPrenotazione: TipoProduzioneXComponenteXPrenotazione;
  isAdulto: boolean;
  riduzione: Riduzione;
  trattamento: Trattamento;
}

export class Supplemento extends Articolo {
  tipoApplicazioneSupplemento: TipoApplicazioneSupplemento;
  tipoSupplemento: TipoSupplemento;
  urlImmagine: string;
  tipoValore: TipoValore;
  isVisualizzaGiorniWeb: boolean;
  isApplicaATuttiComponenti: boolean;
  isServizioWeb: boolean;
  sconto: number;
  isAttivaInserimentoRapidoInPreventivo: boolean;
  isApplicaGiornoPartenza: boolean;
  isVisualizzaEnfant: boolean;
  isDisattivaSceltaGiorni: boolean;
}

export class Riduzione extends Articolo {
  isRiduzioneAPrezzoFisso: boolean;
  tipoComponentePrenotazione: TipoComponentePrenotazione;
  isAttivo: boolean;
  etaMinima: number;
  etaMassima: number;
}

export class ArticoloXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  articolo: Articolo;
}

export class Cancellazione extends BaseAlbergo {
  nome: string;
  accontoCaparra: number;
  accontoCaparraTipoValore: TipoValore;
  isAttivo: boolean;
  isCancellazioneGratuita: boolean;
  isNonRimborsabile: boolean;
  isPagaHotel: boolean;
  isCartaCreditoGaranzia: boolean;
  oreCancellazioneGratuitaPrimaCheckIn: number;
  oidModalitaPagamento: string;
}

export class DettaglioCancellazione extends Base {
  da: number;
  a: number;
  tipoPenaleCancellazione: TipoPenaleCancellazione;
  valore: number;
  cancellazione: Cancellazione;
}

export class CancellazioneXLingua extends Base {
  nome: string;
  note: string;
  descrizione: string;
  lingua: Lingua;
  cancellazione: Cancellazione;
}

export class ModalitaPagamento extends BaseAlbergo {
  nome: string;
  ordinamento: number;
  email: string;
  caparra: number;
  isPercentuale: boolean;
  numeroNottiCaparra: number;
  isCaparraPerCamera: boolean;
  importoMinimoCaparraPercentuale: number;
  oreConferma: number;
  isPrenotazioniConfermateAutomaticamente: boolean;
  isCreaCaparraInWelcome: boolean;
  isCreaCaparraInWelcomeIncassoImmediato: boolean;
  isAttivo: boolean;
  isAttivoBookingExtra: boolean;
  isAttivoMyPage: boolean;
  isAttivoPayMail: boolean;
  isDefault: boolean;
  isVisualizzaInPagamenti: boolean;
  validaDal: string;
  validaAl: string;
  tipo: TipoModalitaPagamento;
  politicaCancellazione: Cancellazione;
  isTest: boolean;
  oreValiditaPrimaCheckIn: number;
  massimoOreValiditaPrimaCheckIn: number;
  iban: string;
  banca: string;
  intestatarioConto: string;
  swift: string;
  intestazione: string;
  xPayAlias: string;
  xPaySecretKey: string;
  xPayTipoPrenotazione: TipoPrenotazioneXPay;
  xPayCodiceStruttura: string;
  xPayPagamentoRicorrente: boolean;
  xPayTerminiCondizioni: string;
  xPayGiorniNessunRimborso: number;
  xPayGiorniRimborsoTotale: number;
  xPayGiorniRimborsoParziale: number;
  xPayPercentualeRimborso: number;
  payWayTerminalId: string;
  payWaySecretKey: string;
  unicreditTerminalId: string;
  unicreditSecretKey: string;
  tPayTerminalId: string;
  tPaySecretKey: string;
  stripeSecretKey: string;
  stripePublicKey: string;
  gestpayApiKey: string;
  gestpayShopId: string;
  paypalClientId: string;
  paypalSecretKey: string;
  sumUpMerchantId: string;
  sumUpClientId: string;
  sumUpSecretKey: string;
  addonPaymentsMerchantId: string;
  addonPaymentsSecretKey: string;
  beSafePayApiKey: string;
  satispayKeyId: string;
  hobexEntityId: string;
  hobexAccessToken: string;
  axeptaApiKey: string;
  axeptaApiKeySmartCheckout: string;
  axeptaAccessToken: string;
  holipayHotelId: string;
  holipaySecretKey: string;
  siapayShopId: string;
  siapaySecretKey: string;
  scalaPayApiKey: string;
  virtualPayMerchantId: string;
  virtualPayABI: string;
  virtualPaySecretKey: string;
  myPOSWalletNumber: string;
  myPOSSID: string;
  myPOSKeyIndex: number;
  myPOSPrivateKey: string;
  myPOSPublicCertificate: string;
  vivaWalletClientId: string;
  vivaWalletSecretKey: string;
  isAssegnaProgressivoCaparraInWelcome: boolean;
  tipoContabilizzazione: TipoContabilizzazione;
  statoPrenotazioneWelcomeDefault: StatoPrenotazioneWelcome;
  numeroGiorniScadenzaOpzione: number;
  tipoPagamentoWelcome: TipoPagamento;
  ubicazioneIstat: UbicazioneIstat;
  template: Template;
  isUsePost: boolean;
  xPayVerificaCartaCC: boolean;
  oidAlbergo: number;
}

export class ModalitaPagamentoXLingua extends Base {
  nome: string;
  note: string;
  descrizione: string;
  testoBottonePaga: string;
  lingua: Lingua;
  modalitaPagamento: ModalitaPagamento;
}

export class Servizio extends BaseAlbergo {
  nome: string;
  ordinamento: number;
  iconaCss: string;
  isDisponibile: boolean;
  isModelloPassepartout: boolean;
  urlImmagine: string;
  categoria: CategoriaServizio;
}

export class ServizioXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  servizio: Servizio;
}

export class TagCrm extends BaseAlbergo {
  nome: string;
  ordinamento: number;
  colore: number;
  coloreHex: string;
  isVisualizzaContenutiSeparati: boolean;
  isDefault: boolean;
  oidContenuti: string;
  oidArticoli: string;
  urlHeaderMyPage: string;
  urlImmagineSfondo: string;
  ubicazioneIstat: UbicazioneIstat;
  coloreMyPage: number;
  coloreMyPageHex: string;
  coloreSecondarioMyPage: number;
  coloreSecondarioMyPageHex: string;
  tags: TagCrmXLingua[];
}

export class TagCrmXLingua extends Base {
  testo: string;
  testoMyPage: TestoMyPage;
  lingua: Lingua;
  tagCrm: TagCrm;
}

export class TagCrmImmagini extends Base {
  ordinamento: number;
  urlImmagine: string;
  base64String: string;
  tagCrm: TagCrm;
}

export class VoceAddebito extends BaseAlbergo {
  nome: string;
  ordinamento: number;
  isVisualizzaEspanso: boolean;
  urlImmagine: string;
  vociAddebito: VoceAddebitoXLingua[];
}

export class VoceAddebitoXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  voceAddebito: VoceAddebito;
}

export class Portale extends Base {
  nome: string;
  colore: number;
  coloreHex: string;
  url: string;
  urlImmagineLogo: string;
  urlImmagineIcona: string;
  urlGetRisorse: string;
  urlGetTariffe: string;
  tipoPortale: TipoPortale;
  userID: string;
}

export class UbicazioneIstat extends BaseAlbergo {
  nome: string;
  prefissoCodicePreventivo: string;
  prossimoNumeroPreventivo: number;
  isRoomServiceAttivo: boolean;
  isVisualizzaEventi: boolean;
  isSceltaMenuAttiva: boolean;
  coloreMySelf: string;
  oidContenuti: string;
  oidArticoli: string;
  urlImmagineSfondo: string;
  urlHeaderMySelf: string;
  isRichiediPagamentoArticoliECommerce: string;
  isVisualizzaFiltroAllergeni: string;
  citta: string;
  postiLetto: number;
  camereEffettive: number;
  modalitaSceltaMenuMySelf: ModalitaSceltaMenuMySelf;
  timeLimitColazione: string;
  timeLimitPranzo: string;
  timeLimitCena: string;
}

export class UbicazioneIstatXLingua extends Base {
  testoIniziale: string;
  testoIniziale2: string;
  lingua: Lingua;
  ubicazioneIstat: UbicazioneIstat;
}

export class Valuta extends BaseAlbergo {
  descrizione: string;
}

export class Agenzia extends BaseAlbergo {
  ragioneSociale: string;
  sourceBrand: string;
  isNascondiImportiSelfCheckIn: boolean;
  tipoAnagrafica: TipoAnagrafica;
}

export class PortaleXAlbergo extends BaseAlbergo {
  portale: Portale;
  tipoPortale: TipoPortale;
  stato: StatoPortaleXAlbergo;
  nome: string;
  descrizione: string;
  ordinamento: number;
  hotelCode: string;
  chainCode: string;
  fromPartyID: string;
  userID: string;
  password: string;
  passwordMask: string;
  valuta: Valuta;
  agenzia: Agenzia;
  agenziaCrm: Agenzia;
  accountMailCrm: AccountMail;
  trattamentoDefault: Trattamento;
  portaleXAlbergoMaster: PortaleXAlbergo;
  codiceValuta: string;
  simboloValuta: string;
  tipoAnalytics: TipoAnalytics;
  tipoBilanciamentoInterno: TipoBilanciamentoInterno;
  isAggiornaDisponibilitaCollegateAltriPortali: boolean;
  isAttivo: boolean;
  isPrenotazioniConfermateAutomaticamente: boolean;
  isModificaPrenotazioneInWelcome: boolean;
  isEliminaPrenotazioneInWelcome: boolean;
  isAvvisaNuovaPrenotazione: boolean;
  isRipristinaDisponibilitaSuCancellazione: boolean;
  isInviaMailConfermaPassepartoutAuto: boolean;
  statoPrenotazioneWelcomeDefault: StatoPrenotazioneWelcome;
  numeroGiorniScadenzaOpzione: number;
  isTripConnectAttivo: boolean;
  isGardaSeeAttivo: boolean;
  isTrivagoAttivo: boolean;
  isColazioneTrivagoAttiva: boolean;
  isApriTariffaSeDisponibiliMaggioreZero: boolean;
  isApriCtaCtdSeDisponibiliMaggioreZero: boolean;
  isChiudiTariffaSeDisponibiliMinoreZero: boolean;
  isVisualizzaRichiesteCrm: boolean;
  isVisualizzaInComparatoreTariffe: boolean;
  isAggiornaMinMaxStayMaster: boolean;
  //isPropagaBloccoStatoPortaliCollegati: boolean;
  isPubblicaPrezzi: boolean;
  isPubblicaRegolePrenotazione: boolean;
  //isVisualizzaPrimaPubblicazione: boolean;
  isVisualizzaPrenotate: boolean;
  isVisualizzaPrezzo: boolean;
  isAttivoDurataSoggiornoMinimo: boolean;
  isAttivoDurataSoggiornoMassimo: boolean;
  isVisualizzaSogliaMinimaMassima: boolean;
  isAttivoCta: boolean;
  isAttivoCtd: boolean;
  isAttivaFascia: boolean;
  isAttivaPrezzoBase: boolean;
  isAttivoVariazioneDisponibili: boolean;
  isVisualizzaSoloTariffaMigliore: boolean;
  isControllaDurateSoggiornoSulGiornoDiArrivo: boolean;
  isEtaRiduzioniAttiva: boolean;
  isFiltroTariffaAttivo: boolean;
  isVisualizzaTotaleSoggiornoSeNonDisponibile: boolean;
  isVisualizzaCamereNonPrenotabili: boolean;
  isComparazioneTariffeAttivo: boolean;
  isVerificaCartaCredito: boolean;
  isVisualizzaCRO: boolean;
  isVisualizzaDisponibilitaCalendario: boolean;
  isVisualizzaPrezzoCalendario: boolean;
  isProgressivoPreventivoXUbicazione: boolean;
  isVisualizzaLogo: boolean;
  tipoVisualizzazioneGrigliaDisponibilita: TipoVisualizzazioneGrigliaDisponibilita;
  nomeStruttura: string;
  indirizzo: string;
  citta: string;
  cap: string;
  provincia: string;
  telefono: string;
  telefonoWhatsApp: string;
  fax: string;
  email: string;
  ubicazioneIstat: UbicazioneIstat;
  campoPersonalizzatoEmail: string;
  linkSitoWeb: string;
  tipologia: TipologiaAlbergo;
  stelle: StelleAlbergo;
  partitaIva: string;
  numeroCCIA: string;
  urlIFrameGoogleMap: string;
  googlePlaceId: string;
  //apiKeyCustomerAlliance: string;
  //apiKeyTravelAppeal: string;
  dataInizioGestione: string;
  dataFineGestione: string;
  oidServizi: string;
  oidArticoliBookingExtra: string;
  urlImmagine: string;
  urlImmagineSfondo: string;
  urlImmagineSfondoBookingExtra: string;
  urlImmagineLogo: string;
  urlImmagineLogoMobile: string;
  base64Immagine: string;
  base64ImmagineSfondo: string;
  base64ImmagineLogo: string;
  numeroUltimePrenotazioni: number;
  numeroPersoneCollegate: number;
  colore: number;
  coloreHex: string;
  isVisualizzaCondizioniPrenotazioneStep2: boolean;
  isAccettaContrattoPrenotazioneStep2: boolean;
  isVisualizzaDateAlternative: boolean;
  isVisualizzaCalendarioMobile: boolean;
  isCamereLibereStep1Visualizzate: boolean;
  isPaxStep1Visualizzate: boolean;
  isPaxRichiestaStep1Visualizzate: boolean;
  isRichiediDisponibilitaStep1Visualizzata: boolean;
  isEscludiTariffeMinLosInferiore: boolean;
  isEscludiTariffeMaxLosSuperiore: boolean;
  isEscludiPromozioniNonPrenotabili: boolean;
  isDurataPacchettoUgualeARichiesta: boolean;
  isSupplementiConPrezzoMaggioreZero: boolean;
  camerePrenotabili: number;
  camerePrenotabiliCrm: number;
  adultiDefaultInPrenotazione: number;
  numeroMassimoAdulti: number;
  numeroMassimoRiduzioni: number;
  etaMinimaBambini: number;
  etaMassimaBambini: number;
  tipoOrdinamentoTariffe: TipoOrdinamentoTariffe;
  facebookPageId: string;
  facebookPixel: string;
  googleUA: string;
  googleGTM: string;
  isVisualizzaChatFacebookMyPage: boolean;
  isVisualizzaChatFacebookBooking: boolean;
  isVisualizzaDettagliPropostaMyPage: boolean;
  listinoBookingExtra: Listino;
  versioneMyPage: VersioneMyPage;
  versioneSelfCheckIn: VersioneSelfCheckIn;
  modelloPrezzo: ModelloPrezzo;
  hasModelloPrezzo: boolean;
  importoMinimoXCompatoreTariffe: number;
  nomePortaleCompatoreTariffe: string;
  isRichiediPasswordSelfCheckIn: boolean;
  isVisualizzaDettaglioGiornaliero: boolean;
  campiObbligatoriPreventivo: string;
  campiObbligatoriFormRichiesta: string;
  campiObbligatoriMyPage: string;
  campiObbligatoriBooking: string;
  campiObbligatoriECommerce: string;
  campiObbligatoriSelfCheckIn: string;
  isInviaEmailHotelFormRichiesta: boolean;
  isVisualizzaTipoCameraFormRichiesta: boolean;
  isVisualizzaTrattamentoFormRichiesta: boolean;
  coloreSelfCheckIn: string;
  isAttivaBookingExtraSelfCheckIn: boolean;
  isAttivaUpSellingSelfCheckIn: boolean;
  isAttivaCancellazioneSelfCheckIn: boolean;
  isEliminaPrenotazioneSelfCheckIn: boolean;
  isRichiediPasswordCancellazionePrenotazioneSelfCheckIn: boolean;
  isVisualizzaTuttiDatiSelfCheckIn: boolean;
  dominiOTASelfCheckIn: string;
  isAttivaSpedizioneBookingExtra: boolean;
  isVisualizzaPrezzoMinimo: boolean;
  linguaDefaultSelfCheckIn: Lingua;
  isVisualizzaRiepilogoPrenotazioneSelfCheckIn: boolean;
  isNascondiChatSelfCheckIn: boolean;
  isNascondiChatMyPage: boolean;
  affiliredID: string;
  isVisualizzaProposteEspanse: boolean;
  isVisualizzaTariffeEspanseBooking: boolean;
  isImportaPrenotazioniConfermateMrPreno: boolean;
  isImportaCaparraMrPreno: boolean;
  isImportaCaparraMrPrenoDopoPagamento: boolean;
  isImportaPrezziGiornalieriMrPreno: boolean;
  isImportaPrenotazioniNettoCommissioni: boolean;
  isImportaSpesePuliziaAirBnb: boolean;
  tipoVisualizzazioneBanner: TipoVisualizzazioneBanner;
  timeoutChiusuraBanner: number;
  templateStampaPrenotazioneMyPage: Template;
  templateStampaPrenotazioneSelfCheckIn: Template;
  templatePrenotazioneRifiutataClienteSelfCheckIn: Template;
  templatePrenotazioneEliminataClienteSelfCheckIn: Template;
  isSourceBrandXAgenziaAttivo: boolean;
  isPoliticheCancellazioniAttivo: boolean;
  isServiziOTAAttivo: boolean;
  hasTariffeOTADerivate: boolean;
  isNascondiPromozioniSeVieneInseritoCodicePromozionale: boolean;
  isVisualizzaDescrizionePoliticaCancellazione: boolean;
  isVisualizzaDescrizioneDettagliataTariffa: boolean;
  isRichiediInformazioniOspiti: boolean;
  isDividiRettaPerOspite: boolean;
  isVisualizzaRiepilogoPagamentoMyPage: boolean;
  isApplicaTassaSoggiornoCRM: boolean;
  percentualeMinimaScontoMyPage: number;
  isCreaPrenotazioniPrezziScontati: boolean;
  templateDescrizioneDettaglioProposta: string;
  isVisualizzaInformazioniPropostaMyPage: boolean;
  isAggiungiMessaggiAutomaticiChatPreventivo: boolean;
  isBloccaModificaDatiCheckIn: boolean;
  isNascondiPromozioniInEvidenza: boolean;
  tipoScontoDefaultDettagliPreventivo: TipoValore;
  tipoVisualizzazioneImmaginePrenotazione: TipoVisualizzazioneImmaginePrenotazione;
  orarioDiArrivoMinimoSelfCheckIn: string;
  orarioDiArrivoMassimoSelfCheckIn: string;
  isDisattivaRichiestaBambiniBooking: boolean;
  isDisattivaRichiestaBambiniFormRichiesta: boolean;
  isModificaDisponibiliAttiva: boolean;
  isDisattivaCheckInMyPage: boolean;
  bannerFormRichiesta: string;
  coloreBannerFormRichiesta: string;
  isVisualizzaPrenotazioneEliminataSelfCheckIn: boolean;

  isPubblicaPrezziAttivo: boolean;
  isPubblicaRegolePrenotazioneAttivo: boolean;

  isFromPartyIDAttivo: boolean;
  isChainCodeAttivo: boolean;

  latitude: string;
  longitude: string;

  isGoogleHotelsTravelAttivo: boolean;

  twoLetterCountryCode: string;

  creditoHotelCollect: Credito;
  creditoPortaleCollect: Credito;

  parametroMercatoDefault: ParametroRicerca;
  parametroCanaleVenditaDefault: ParametroRicerca;

  sondaggioDefault: Sondaggio;

  templateDefaultRichiestaCaparra: Template;
  modalitaPagamentoDefaultRichiestaCaparra: string;

  isVisualizzaBannerCookiesBooking: boolean;
  isRichiediDatiFatturazioneBooking: boolean;
  isDatiFatturazioneObbligatoriBooking: boolean;
  isInviaMailConfermaPagamentoManualeCrm: boolean;
  isVisualizzaRifiutaOffertaMyPage: boolean;

  urlFacebook: string;
  urlInstagram: string;

  isRecuperaPrenotazioni: boolean;

  isProponiNottiCalendarioBooking: boolean;

  emailMyPage: string;

  tipoRichiestaDefault: TipoRichiestaPreventivo;
  tipoInvioEmailCheckInOnline: TipoInvioEmail;

  isDividiCaparraCamere: boolean;

  isVisualizzaStepBooking: boolean;

  isNascondiImportiDopoCheckOutSelfCheckIn: boolean;

  isVisualizzaLinkBookingExtra: boolean;
  isVisualizzaBottoniFiltroVoceAddebitoBookingExtra: boolean;
  isAttivaBuonoRegaloBookingExtra: boolean;

  isImportaServiziExtraComeSupplementiAttivo: boolean;
  isImportaServiziExtraComeSupplementi: boolean;

  oreMassimeCheckIn: number;

  urlFavicon: string;

  isVisualizzaCamereCompatteBooking: boolean;
  isVisualizzaPastiBooking: boolean;

  isVisualizzaPopupSalvataggioRicercaBookingEngine: boolean;

  isPrenotazioniWS: boolean;

  constructor(oid?: number) {
    super(oid);
  }
}

export class PortaleXAlbergoXLingua extends Base {
  descrizione: string;
  condizionePrenotazione: string;
  descrizioneBookingDayUse: string;
  descrizioneBookingExtra: string;
  descrizioneFinale: string;
  descrizionePopup: string;
  condizioneContratto: string;
  testoSelfCheckIn: string;
  testoNoDisponibilita: string;
  bulletPoint1: string;
  bulletPoint2: string;
  bulletPoint3: string;
  traduzioniJSON: string;
  traduzioniText: string;
  privacyText: string;
  newsLetterText: string;
  reportText: string;
  urlTraduzioni: string;
  urlPrivacy: string;
  urlNewsLetter: string;
  urlReport: string;
  urlRedirectFormRichiesta: string;
  lingua: Lingua;
  portaleXAlbergo: PortaleXAlbergo;
}

export class LogRicercaPortaleXAlbergo {
  data: string;
  arrivo: string;
  ricercheDesktop: number;
  ricercheMobile: number;
  tariffePrenotabili: number;
  prenotazioni: number;
  revenue: number;
  roomNight: number;
  ADR: number;
  oidPortaleXAlbergo: number;
}

export class Dashboard extends BaseAlbergo {
  nome: string;
  tipoGrafico: TipoGrafico;
  tipoDato: TipoDatoWelcomeDashboard;
  tipoValore: TipoValoreWelcomeDashboard;
  percentualeSchermo: PercentualeSchermoWelcomeDashboard;
  ordinamento: number;
}

export class Prenotazione extends BaseAlbergo {
  arrivo: string;
  partenza: string;
  codiceOTA: string;
  codicePrenotazione: string;
  uid: string;
  noteP: string;
  supplementi: string;
  motivoRifiuto: string;
  portaleXAlbergo: PortaleXAlbergo;
  cliente: Cliente;
  importo: number;
  caparra: number;
  tipoCamera: TipoCamera;
  tipoCameraVendita: TipoCamera;
  tipoCameraOTA: TipoCameraOTA;
  importata: boolean;
  isEliminata: boolean;
  dataPren: string;
  camera: string;
  trattamento: Trattamento;
  tariffaOTA: TariffaOTA;
  promozione: Promozione;
  codicePromozione: CodicePromozione;
  sondaggio: Sondaggio;
  cancellazione: Cancellazione;
  sourceBrand: string;
  companyInfo: string;
  stayID: string;
  pax: number;
  notti: number;
  noteImportazioneWelcome: string;
  tipoPrenotazione: TipoPrenotazione;
  statoPrenotazione: StatoPrenotazione;
  parametroMercato: ParametroRicerca;
  parametroCanaleVendita: ParametroRicerca;
  parametroSegmento: ParametroRicerca;
  parametroFonte: ParametroRicerca;
  sistemazione: Sistemazione;
  modalitaPagamento: ModalitaPagamento;
  preventivo: Preventivo;
  oraArrivo: string;
  statoPrenotazionePortale: string;
  statoPrenotazioneWelcome: StatoPrenotazioneWelcome;
  sconto: number;
  scontoVoucher: number;
  notValidMessage: string;
  ospiti: ComponenteXPrenotazione[];
  dataCancellazione: string;
  dataRichiestaCancellazione: string;
  motivoViaggio: MotivoViaggio;
  transazione: Transazione;
  oidAlbergo: number;
  isPrezziScontati: boolean;
  oidPrenotazioneCollegata: number;
  noteTrasferimentoPrenotazione: string;
  dataCreazioneCaparra: string;
  agenzia: Agenzia;
  azienda: Agenzia;
  upgradeCamera: string;
  isNotificataAGestionale: boolean;
  codiceRiferimentoOperazione: string;
  scadOpz: string;
  importoTassaSoggiorno: number;
  pianoTariffario: string;
  dataModificaWelcome: string;
  causaleCancellazione: CausaleOperazione;
}

export class ArticoloXPrenotazione extends BaseAlbergo {
  nome: string;
  tipoGrafico: TipoGrafico;
  tipoDato: TipoDatoWelcomeDashboard;
  tipoValore: TipoValoreWelcomeDashboard;
  percentualeSchermo: PercentualeSchermoWelcomeDashboard;
  ordinamento: number;
}

export class PrenotazioneExtra extends Base {
  data: string;
  totale: number;
  cliente: Cliente;
  modalitaPagamento: ModalitaPagamento;
  portaleXAlbergo: PortaleXAlbergo;
  articoli: PrenotazioneExtraArticoli[];
  statoPrenotazione: StatoPrenotazione;
  tipoPrenotazioneExtra: TipoPrenotazioneExtra;
  dataVisualizzazione: string;
  indirizzo: string;
  citta: string;
  provincia: string;
  cap: string;
  nazione: string;
  noteP: string;
  messaggioBuonoRegalo: string;
  nomeRiceventeBuonoRegalo: string;
  emailRiceventeBuonoRegalo: string;
  risorsa: Risorsa;
  tariffaOTA: TariffaOTA;
  dal: string;
  al: string;
  dataAppuntamento: string;
  oraAppuntamento: string;
  prenotazione: Prenotazione;
}

export class PrenotazioneExtraArticoli extends Base {
  prezzo: number;
  quantita: number;
  totale: number;
  sconto: number;
  note: Cliente;
  giorni: string;
  giorniString: string;
  articolo: Articolo;
  prenotazioneExtra: PrenotazioneExtra;
}

export class PortaleXAlbergoStorico extends Base {
  anno: number;
  prenotazioni: number;
  prenotazioniEuro: number;
  preventivi: number;
  preventiviEuro: number;
  richieste: number;
  portaleXAlbergo: PortaleXAlbergo;
}

export class Preventivo extends BaseAlbergo {
  arrivo: string;
  partenza: string;
  codicePreventivo: string;
  dataPreventivo: string;
  dataScadenza: string;
  dataScadenzaAccontoCaparra: string;
  dataCancellazione: string;
  dataVisualizzazione: string;
  dataPrenotazione: string;
  dataConfermaPagamento: string;
  dataInvio: string;
  cliente: Cliente;
  totale: number;
  caparra: number;
  isCaparraPercentuale: boolean;
  testoIniziale: string;
  testoFinale: string;
  tagCrm: TagCrm;
  uid: string;
  lingua: Lingua;
  portaleXAlbergo: PortaleXAlbergo;
  statoPreventivo: StatoPreventivo;
  hasMessaggiCliente: boolean;
  oidContenutiMyPage: string;
  oidArticoliUpSelling: string;
  note: string;
  noteCliente: string;
  noteRifiuto: string;
  flag: FlagPreventivo;
  utente: Utente;
  isAccettaConPagamentoImmediato: boolean;
  isRimuoviProposteNonDisponibili: boolean;
  numeroVisualizzazioni: number;
  causaleCancellazione: CausaleOperazione;
  modalitaPagamento: ModalitaPagamento;
  richiesta: Richiesta;
  motivoViaggio: MotivoViaggio;
  codicePromozione: CodicePromozione;
  camere: PreventivoCamere[];
  isEliminatoDefinitivamente: boolean;

  constructor(oid?: number) {
    super(oid);
    this.tagCrm = new TagCrm();
  }
}

export class PreventivoCamere extends Base {
  totale: number;
  preventivo: Preventivo;
  proposte: PreventivoCamereProposte[];
  pax: PreventivoCamerePax[];
}

export class PreventivoCamereProposte extends Base {
  descrizione: string;
  arrivo: string;
  partenza: string;
  totale: number;
  totaleScontato: number;
  cancellazione: Cancellazione;
  note: string;
  sconto: number;
  isPercentuale: boolean;
  ordinamento: number;
  dataConferma: string;
  isPrezziPersona: number;
  tipoScontoProposta: TipoScontoProposta;
  pianoTariffario: string;
  camera: PreventivoCamere;
  dettagli: PreventivoCamereProposteDettagli[];
}

export class PreventivoCamereProposteDettagli extends Base {
  descrizione: string;
  tipoDettaglioProposta: TipoDettaglioProposta;
  quantita: number;
  importo: number;
  sconto: number;
  isPercentuale: boolean;
  isExtraIncluso: boolean;
  isManuale: boolean;
  totale: number;
  tipoCameraOTA: TipoCameraOTA;
  tariffaOTA: TariffaOTA;
  promozione: Promozione;
  articolo: Articolo;
  giorni: string;
  giorniString: string;
  data: string;
  camera: string;
  isRimuoviCamera: boolean;
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  componente: Riduzione;
  proposta: PreventivoCamereProposte;
}

export class PreventivoCamerePax extends Base {
  quantita: number;
  tipo: TipoComponentePrenotazione;
  anni: number;
  riduzione: Riduzione;
  camera: PreventivoCamere;
}

export class ClienteMessaggi extends BaseAlbergo {
  mittente: MittenteMessaggio;
  data: string;
  messaggio: string;
  messaggioShort: string;
  parametri: string;
  dataVisualizzazione: string;
  pagina: PaginaMessaggioCliente;
  prenotazione: Prenotazione;
  transazione: Transazione;
  preventivo: Preventivo;
  cliente: Cliente;
}

export class ClienteAppuntamenti extends BaseAlbergo {
  data: string;
  orarioInizio: string;
  orarioFine: string;
  oggetto: string;
  luogo: string;
  note: string;
  cliente: Cliente;
}

export class Nazione extends Base {
  nome: string;
  sigla: string;
  nomeItaliano: string;
  codiceQuestura: string;
  iso2: string;
  isAttiva: boolean;
  isItalia: boolean;
  lingua: Lingua;
}

export class NazioneXLingua extends Base {
  nome: string;
  lingua: Lingua;
  nazione: Nazione;
}

export class Regione extends Base {
  nome: string;
}

export class Comune extends Base {
  nome: string;
  cap: string;
  provincia: string;
  codiceQuestura: string;
}

export class Listino extends BaseAlbergo {
  nome: string;
  tipoListino: TipoListino;
  isDisponibile: boolean;
  isListinoNoFascia: boolean;
  prenotabileDal: string;
  prenotabileAl: string;
  dataModificaWelcome: string;
  isLunedi: boolean;
  isMartedi: boolean;
  isMercoledi: boolean;
  isGiovedi: boolean;
  isVenerdi: boolean;
  isSabato: boolean;
  isDomenica: boolean;
  minimoGiorniDiAnticipo: number;
  massimoGiorniDiAnticipo: number;
}

export class Credito extends BaseAlbergo {
  nome: string;
}

export class Arrotondamento extends BaseAlbergo {
  nome: string;
  descrizione: string;

  constructor(oid?: number) {
    super();
    this.oid = oid;
  }
}

export class DettaglioArrotondamento extends Base {
  da: number;
  a: number;
  tipoArrotondamento: TipoArrotondamento;
  precisione: number;
  arrotondamento: Arrotondamento;
}

export class Fascia extends BaseAlbergo {
  nome: string;
  colore: number;
  coloreHex: string;
  sogliaCalcoloPercentuale: number;
  coefficiente1: number;
  coefficiente2: number;
  listiniConfigurati: string;
  dataUltimaSincronizzazione: string;
  ordinamento: number;
  ubicazioneIstat: ViewUbicazioneIstat;
}

export class TariffaOTA extends Base {
  codice: string;
  descrizione: string;
  trattamento: Trattamento;
  trattamentoUsoSingola: Trattamento;
  listino: Listino;
  discount: number;
  tax: number;
  credito: Credito;
  politicaCancellazione: Cancellazione;
  ordinamento: number;
  prezzoMinimo: number;
  prezzoMassimo: number;
  arrotondamento: Arrotondamento;
  codiceMaster: string;
  tipoVariazionePrezzoMaster: TipoValore;
  valoreVariazionePrezzoMaster: number;
  //percentualeVariazionePrezzoMaster: number;
  oidServizi: string;
  oidModalitaPagamento: string;
  oidPromozioni: string;
  oidSupplementiAbilitati: string;
  portaleXAlbergo: PortaleXAlbergo;
  mealPlanType: MealPlanType;
  codiceHotelDE: string;
  codiceRoomType: string;
  codiceAlternativo: string;
  isPrezzoAggiornabile: boolean;
  isOffertaSegreta: boolean;
  isMobile: boolean;
  isVisualizzaServiziBooking: boolean;
  tipoVisualizzazioneTariffe: TipoVisualizzazioneTariffe;
  validaDal: string;
  validaAl: string;
  isDayUse: boolean;
  isVisualizzaInAPI: boolean;
  isVisualizzaInRichiestaDisponibilita: boolean;
  isInEvidenza: boolean;
  isTariffaPMS: boolean;
  isApplicaVariazioneXTrattamento: boolean;
  pianoTariffario: PianoTariffario;
  isCreaProduzionePMS?: boolean;
  isSelected: boolean;
  erroreConfigurazioneMaster: boolean;
  isInviaGoogleHotel: boolean;
  isVisualizzaDettagliPropostaMyPage: boolean;
  tipoPlanning: string;
  isPrezzoModificabilePlanning: boolean;
  giorniAnticipoSoggiorno: number;
}

export class TariffaOTAXLingua extends Base {
  descrizione: string;
  descrizioneDettagliata: string;
  lingua: Lingua;
  tariffaOTA: TariffaOTA;
}

export class TariffaOTADerivata extends Base {
  codice: string;
  descrizione: string;
  numberOfGuests: number;
  tipoVariazione: TipoValore;
  valoreVariazione: number;
  trattamento: Trattamento;
  tariffaOTA: TariffaOTA;
}

export class TipoCameraOTA extends Base {
  codice: string;
  descrizione: string;
  tipoCamera: TipoCamera;
  tipoCameraHotel: TipoCamera;
  ubicazioneIstatHotel: UbicazioneIstat;
  ordinamento: number;
  disponibiliMassime: number;
  disponibiliDaScalareMaster: number;
  rateType: string;
  isUsoSingola: boolean;
  isRisorsaCrm: boolean;
  isTipoCameraPMS: boolean;
  isDisponibilitaCondivisa: boolean;
  isVisualizzaPrezzoMinimo: boolean;
  isDayUse: boolean;
  isIllimitata: boolean;
  oidServizi: string
  oidSupplementiAbilitati: string;
  oidModalitaPagamento: string;
  portaleXAlbergo: PortaleXAlbergo;
  tipoVisualizzazioneImmagine: TipoVisualizzazioneImmagine;
  dimensione: string;
  oidSistemazioni: string;
  disponibileFinoAlleOre: string;
  numeroAdultiCalcoloPastiOTA: number;
  prezzoExtraBed: number;
  tipoCameraSelfCheckin: TipoCameraOTA;
  occupazioneStandard: number;
  isVisualizzaInRichiestaDisponibilita: boolean;
  roomName: string;
  roomClassificationCode: string;
  erroreConfigurazioneMaster: boolean;
  tipoPlanning: string;
}

export class TariffaOTAXTipoCameraOTA extends Base {
  tariffaOTA: TariffaOTA;
  tipoCameraOTA: TipoCameraOTA;
  isUsoSingola: boolean;
  leadingOccupancy: number;
  codicePianoRestrizioni: string;
  oidComponentiXVariazione: string;
  derivedPrices: DerivedPriceModel;
  portaleXAlbergo: PortaleXAlbergo;
  isSelected: boolean;
}

export class ImmagineXTipoCameraOTA extends Base {
  descrizione: string;
  urlImmagine: string;
  isDefault: boolean;
  ordinamento: number;
  tipoCameraOTA: TipoCameraOTA;
  base64String: string;
}

export class TipoCameraOTAXLingua extends Base {
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  lingua: Lingua;
  tipoCameraOTA: TipoCameraOTA;
}

export class ComponenteXPrenotazione extends BaseAlbergo {
  cognome: string;
  nome: string;
  email: string;
  cellulare: string;
  password: string;
  sesso: Sesso;
  codiceFiscale: string;
  tipoComponentePrenotazione: TipoComponentePrenotazione;
  tipoAnagrafica: TipoAnagrafica;
  cittadinanza: string;
  indirizzo: string;
  comune: Comune;
  nazione: Nazione;
  comuneNascita: Comune;
  nazioneNascita: Nazione;
  dataNascita: string;
  tipoDocumentoEnum: TipoDocumento;
  numeroDocumento: string;
  enteRilascioDocumentoEnum: EnteRilascioDocumento;
  comuneRilascioDocumento: Comune;
  dataRilascioDocumento: string;
  dataScadenzaDocumento: string;
  nazioneRilascioDocumento: Nazione;
  modelloAuto: string;
  targaAuto: string;
  codiceLotteria: string;
  lingua: Lingua;
  isConsensoPrivacy: boolean;
  isConsensoInvioNewsletter: boolean;
  isCheckInOnlineEseguito: boolean;
  isAggiornaSuWelcome: boolean;
  isIntestatarioPrenotazione: boolean;
  prenotazione: Prenotazione;
  riduzione: Riduzione;
  eta: number;
  oraArrivo: string;
  note: string;
  allegati: FileDto[];
  descrizioneRiduzione: string;
  oidSistemazione: number;
}

export class Richiesta extends BaseAlbergo {
  dataRichiesta: string;
  dal: string;
  al: string;
  richiestaJSON: string;
  note: string;
  noteOriginali: string;
  cliente: Cliente;
  camere: RichiestaCamere[];
  portaleXAlbergo: PortaleXAlbergo;
  preventivo: Preventivo;
  tipoRichiesta: TipoRichiestaPreventivo;
  causaleRifiuto: CausaleOperazione;
  dataRifiuto: string;
  urlRichiesta: string;
  urlReferrer: string;
  numeroCamere: number;
  numeroPax: number;
  motivoViaggio: MotivoViaggio;
  dataVisualizzazione: string;
  UTMSource: string;
  UTMMedium: string;
  UTMCampaign: string;
  isDayUse: boolean;

  constructor(oidAlbergo?: number) {
    super(oidAlbergo);
    this.portaleXAlbergo = new PortaleXAlbergo(-1);
    this.cliente = new Cliente();
    this.camere = [];
  }
}

export class RichiestaCamere extends Base {
  richiesta: Richiesta;
  tipoCameraOTA: TipoCameraOTA;
  tariffaOTA: TariffaOTA;
  numeroAdulti: number;
  numeroBambini: number;
  pax: RichiestaCamerePax[];
  nomeTipoCamera: string;
  oidTariffe: number[];

  constructor() {
    super();
    this.pax = [];
    this.tipoCameraOTA = new TipoCameraOTA(-1);
    this.tariffaOTA = new TariffaOTA(-1);
  }
}

export class RichiestaCamerePax extends Base {
  quantita: number;
  tipo: TipoComponentePrenotazione;
  anni: number;
  richiestaCamere: RichiestaCamere;
  riduzione: Riduzione;
}

export class UbicazioneIstatCss extends BaseAlbergo {
  pagina: Pagina;
  htmlElement: HtmlElement;
  valore: string;
  cssStyle: string;
  ubicazioneIstat: UbicazioneIstat;
}

export class DisponibilitaXPortaleXAlbergo extends Base {
  giorno: string;
  portaleXAlbergo: PortaleXAlbergo;
  tipoCameraOTA: TipoCameraOTA;
  tariffaOTA: TariffaOTA;
  disponibili: number;
  variazioneDisponibili: number;
  variazioneDisponibiliHotel: number;
  prezzo: number;
  prezzoUsoSingola: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  statoPortaleXAlbergo: StatoPortaleXAlbergo;
  statoPubblicazione: StatoPubblicazionePortale;
  fasciaAttiva: Fascia;
  isPrezzoBloccato: boolean;
  isStatoPortaleXAlbergoBloccato: boolean;
  dataUltimaPubblicazione: string;
  tipoModifica: TipoModificaDisponibilitaXPortaleXAlbergo;
  disponibilitàXPortaleXAlbergoMaster: DisponibilitaXPortaleXAlbergo;
  note: string;
  modalitaModifica: ModalitaModificaDisponibilitaXPortaleXAlbergo;
  tipoModificaStatoPortaliCollegati: TipoModificaStatoPortaliCollegati;
  prezzoBase: number;
}

export class CodicePromozione extends BaseAlbergo {
  tipoCodicePromozione: TipoCodicePromozione;
  codice: string;
  isAttivo: boolean;
  isApplicaAPromozioni: boolean;
  isVisualizzaPrezziNetti: boolean;
  isUsoInterno: boolean;
  quantita: number;
  quantitaUtilizzata: number;
  isScontoPercentuale: boolean;
  sconto: number;
  validoDal: string;
  validoAl: string;
  prenotazioneDal: string;
  prenotazioneAl: string;
  isLunedi: boolean;
  isMartedi: boolean;
  isMercoledi: boolean;
  isGiovedi: boolean;
  isVenerdi: boolean;
  isSabato: boolean;
  isDomenica: boolean;
  durataMinimaSoggiorno: number;
  note: string;
  oidTariffeAbilitate: string;
  oidRisorseAbilitate: string;
  oidArticoliAbilitati: string;
  oidModalitaPagamentoAbilitate: string;
  oidComponentiXVariazione: string;
  isPerNotte: boolean;
  isNascondiPromozioniSeVieneInseritoCodicePromozionale: boolean;
  politicaCancellazione: Cancellazione;
  oidPrenotazione: number;
  cliente: Cliente;
  mercato: ParametroRicerca;
  canaleVendita: ParametroRicerca;
  segmento: ParametroRicerca;
  fonte: ParametroRicerca;
  arrotondamento: Arrotondamento;
  ubicazioneIstat: UbicazioneIstat;
}

export class CodicePromozioneXLingua extends Base {
  note: string;
  lingua: Lingua;
  codicePromozione: CodicePromozione;
}

export class Banner extends BaseAlbergo {
  nome: string;
  isAttivo: boolean;
  isAttivoDayUse: boolean;
  validoDal: string;
  validoAl: string;
  isLunedi: boolean;
  isMartedi: boolean;
  isMercoledi: boolean;
  isGiovedi: boolean;
  isVenerdi: boolean;
  isSabato: boolean;
  isDomenica: boolean;
  durataMinimaSoggiorno: number;
  isUsaEditor: boolean;
  isVisualizzaInHome: boolean;
  oidUbicazioniIstat: string;
  isMobile: boolean;
}

export class BannerXLingua extends Base {
  titolo: string;
  testo: string;
  design: string;
  lingua: Lingua;
  banner: Banner;
}

export class MotivoViaggio extends BaseAlbergo {
  nome: string;
  ordinamento: number;
  isAttivoWebBooking: boolean;
  isAttivoFormRichiesta: boolean;
  pianoTariffario: PianoTariffario;
  tagCrm: TagCrm;
  parametroMercato: ParametroRicerca;
}

export class MotivoViaggioXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  motivazioneViaggio: MotivoViaggio;
}

export class AlbergoMaster extends BaseAlbergo {
  oidENome: string;
  nome: string;
  email: string;
  telefono: string;
  codice: string;
  numeroMassimoAlberghi: number;
  dominio: string;
  cssMotoreRicerca: string;
  urlImmagineTop: string;
  urlImmagineBottom: string;
  textBottom: string;
  baseColor: string;
  stileCss: string;
  isFiltraPortaliPerTuttiIServizi: boolean;
  isEffettuaRicercaDms: boolean;
  tipologieAlbergoDms: string;
  stelleAlbergoDms: string;
  oidPortaliXAlbergo: string;
}

export class AlbergoMasterXLingua extends Base {
  descrizione: string;
  testoPrimaHotel: string;
  testoDopoHotel: string;
  overlayImmagine: string;
  bannerFormRichiesta: string;
  lingua: Lingua;
  albergoMaster: AlbergoMaster;
}

export class AlbergoMasterImmagini extends Base {
  urlImmagine: string;
  base64String: string;
  ordinamento: number;
  albergoMaster: AlbergoMaster;
}

export class Recensione extends Base {
  nome: string;
  url: string;
  data: string;
  dataPrenotazione: string;
  voto: number;
  votoHover: number;
  fonte: FonteRecensione;
  isVisualizzaInHomePage: boolean;
  isVisualizzaMyPage: boolean;
  portaleXAlbergo: PortaleXAlbergo;
  cliente: Cliente;
  isSelfCheckIn: boolean;
  limiteCaratteri: number;
}

export class Transazione extends BaseAlbergo {
  data: string;
  tipoContabilizzazione: TipoContabilizzazione;
  importo: number;
  statoContabilizzazione: StatoContabilizzazione;
  cliente: Cliente;
  prenotazione: Prenotazione;
  statoEsecuzione: StatoEsecuzioneTransazione;
  idTransazione: string;
  note: string;
  urlRisposta: string;
  urlRichiesta: string;
  isPayMail: boolean;
  modalitaPagamento: ModalitaPagamento;
  codTrans: string;
  descrizioneEsito: string;
  dataEsecuzione: string;
  customer: string;
  reservation: string;
  isPrenotazioneCreata: boolean;
  oidAlbergo: number;
}

export class RecensioneXLingua extends Base {
  titolo: string;
  descrizione: string;
  lingua: Lingua;
  recensione: Recensione;
}

export class BloccoHtml extends Base {
  nome: string;
  tipo: TipoBloccoHtml;
  ordinamento: number;
  isAttivo: boolean;
  stileCSS: string;
  portaleXAlbergo: PortaleXAlbergo;
}

export class BloccoHtmlXLingua extends Base {
  nome: string;
  html: string;
  lingua: Lingua;
  bloccoHtml: BloccoHtml;
}

export class ReportHotel extends BaseAlbergo {
  nome: string;
  data: string;
  urlReport: string;
}

export class PortaleXAlbergoImmagini extends Base {
  ordinamento: number;
  urlImmagine: string;
  base64String: string;
  portaleXAlbergo: PortaleXAlbergo;
}

export class SourceBrandXAgenzia extends Base {
  codiceSourceBrand: string;
  agenzia: Agenzia;
  portaleXAlbergo: PortaleXAlbergo;
}

export class Promozione extends BaseAlbergo {
  nome: string;
  codicePromozione: string;
  urlImmagine: string;
  urlImmagineEvidenza: string;
  ordinamento: number;
  tipoPromozione: TipoPromozione;
  politicaCancellazione: Cancellazione;
  isAttiva: boolean;
  isAttivaSoloMobile: boolean;
  isVisualizzaInHomePage: boolean;
  isOffertaSegreta: boolean;
  isAttivaTariffaScontata: boolean;
  isVisualizzaSoloDescrizionePromozione: boolean;
  oidModalitaPagamento: string;
  oidTipoCamera: string;
  oidTrattamenti: string;
  oidLingueAttive: string;
  oidSupplementiAbilitati: string;
  prenotabileDal: string;
  prenotabileAl: string;
  prezzoHome: number;
  isUsaPrezzoBaseHome: boolean;
  isVisualizzaPrezziNetti: boolean;
  giorniValidita: string;
  isLunedi: boolean;
  isMartedi: boolean;
  isMercoledi: boolean;
  isGiovedi: boolean;
  isVenerdi: boolean;
  isSabato: boolean;
  isDomenica: boolean;
  dataModificaWelcome: string;
  minimoGiorniDiAnticipo: number;
  massimoGiorniDiAnticipo: number;
  quantitaMassima: number;
  isExtranet: boolean;
  tipoApplicazione: TipoApplicazionePromozione;
  isApplicaPoliticaCancellazioneTariffa: boolean;
  isVisualizzaSupplementiTariffa: boolean;
  oidComponentiXVariazione: string;
  validitaOffertaPeriodo: ValiditaOffertaPeriodo;
}

export class DettaglioPromozione extends Base {
  modalitaCalcoloPrezzo: ModalitaCalcoloPrezzo;
  quantita: number;
  data: string;
  importo: number;
  isPerPersona: boolean;
  tipoDisponibilitaArticolo: TipoDisponibilitaArticolo;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  tipoProduzioneXComponenteXPrenotazione: TipoProduzioneXComponenteXPrenotazione;
  isAdulto: boolean;
  riduzione: Riduzione;
  promozione: Promozione;
  tipoCamera: TipoCamera;
  articolo: Articolo;
  listino: Listino;
}

export class PromozioneXLingua extends Base {
  nome: string;
  descrizione: string;
  descrizioneDettagliata: string;
  lingua: Lingua;
  promozione: Promozione;
}

export class TipoCartaCreditoXAlbergo extends BaseAlbergo {
  nome: string;
  formatoNumero: string;
  formatoPin: string;
  lunghezzaNumero: number;
  lunghezzaPin: number;
  isDisponibile: boolean;
  tipoCartaCredito: TipoCartaCredito;
}

export class Template extends BaseAlbergo {
  nome: string;
  head: string;
  isAttivo: boolean
  ordinamento: number;
  isModelloPassepartout: boolean;
  tipoTemplate: TipoTemplate;
  ubicazioneIstat: UbicazioneIstat;
  urlImmagine: string;
  coloreSfondo: number;
  coloreSfondoHex: string;
  isUsaEditor: boolean;
  accountMail: AccountMail;
  oidAllegati: string;
  cc: string;
}

export class Allegato extends BaseAlbergo {
  nome: string;
  base64: string;
  urlAllegato: string;
}

export class TemplateTags extends Base {
  nome: string;
  tipoTemplates: string;
  categoria: string;
}

export class TemplateXLingua extends Base {
  titolo: string;
  testo: string;
  design: string;
  oidAllegati: string;
  selectedAllegati: number[];
  lingua: Lingua;
  template: Template;
  allegati: Allegato[];
}

export class ServizioDms extends Base {
  nome: string;
  oidServizi: string;
  albergoMaster: AlbergoMaster;
}

export class ServizioDmsXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  servizioDms: ServizioDms;
}

export class ChiusuraGiornalieraHotel extends BaseAlbergo {
  data: string;
  totaleProduzione: number;
  presenzeTotali: number;
  camereOccupate: number;
  ricavoMedioPax: number;
  ricavoMedioCamera: number;
  indiceOccupazione: number;
  revPar: number;
  urlReportChiusura: string;
  urlReportDocumentiEmessi: string;
}

export class Sistemazione extends BaseAlbergo {
  nome: string;
  iconaCss: string;
  urlImmagine: string;
  preparazioneCameraWelcome: PreparazioneCamera;
}

export class PreparazioneCamera extends BaseAlbergo {
  descrizione: string;
}

export class SistemazioneXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  sistemazione: Sistemazione;
}

export class UpSelling extends BaseAlbergo {
  nome: string;
  isAttivo: boolean;
  arrivoDal: string;
  arrivoAl: string;
  tipoPrenotazione: TipoPrenotazione;
  oidTrattamentiAbilitati: string;
  oidTipiCamereUpgrade: string;
  oidArticoliAbilitati: string;
  prezzoCameraUpgrade: number;
  sconto: number;
  scontoArticoli: number;
  tipoCameraPrenotazione: TipoCamera;
  durataMinimaSoggiorno: number;
  disponibiliMinime: number;
  giorniMinimiPrimaArrivo: number;
  giorniMassimiPrimaArrivo: number;
}

export class UpSellingXLingua extends Base {
  testoIniziale: string;
  note: string;
  lingua: Lingua;
  upSelling: UpSelling;
}

export class LogOperazionePortaleXAlbergo extends Base {
  data: string;
  nomePortale: string;
  descrizioneTipoOperazione: string;
  descrizioneEsito: string;
  tipoOperazionePortaleXAlbergo: TipoOperazionePortaleXAlbergo;
  tipoEsitoOperazionePortaleXAlbergo: TipoEsitoOperazionePortaleXAlbergo;
  oidPortaleXAlbergo: number;
  codiciPrenotazione: string;
  warnings: string;
  errori: string;
  xmlRichiesta: string;
  xmlRisposta: string;
  errorePortale: string;
}

export class LogDisponibilitaPortaleXAlbergo extends Base {
  dataPubblicazione: string;
  nomePortaleXAlbergo: string;
  oidPortaleXAlbergo: number;
  giorno: string;
  descrizioneTipoCameraOTA: string;
  descrizioneTariffaOTA: string;
  oidTipoCameraOTA: number;
  oidTariffaOTA: number;
  disponibili: number;
  statoCta: StatoCtaCtd;
  statoCtd: StatoCtaCtd;
  codiceTipoCameraOTA: string;
  codiceTariffaOTA: string;
  variazioneDisponibili: number;
  prezzo: number;
  prezzoUsoSingola: number;
  prezzoExtraBed: number;
  durataMinimaSoggiorno: number;
  durataMassimaSoggiorno: number;
  fascia: string;
  note: string;
  durataEsecuzione: number;
  statoPortaleXAlbergo: StatoPortaleXAlbergo;
  tipoModifica: TipoModificaDisponibilitaXPortaleXAlbergo;
  tipoOperazionePortaleXAlbergo: TipoOperazionePortaleXAlbergo;
  proprietaModificata: string;
}

export class ComponenteXVariazione extends BaseAlbergo {
  nome: string;
  dizionarioRiduzioni: string;
  descrizioneRiduzioni: string;
  isVisualizzaDescrizioneSuTipoCamera: boolean;
}

export class ComponenteXVariazioneXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  componenteXVariazione: ComponenteXVariazione;
}

export class TipoCameraOTAXComponente extends Base {
  isAttiva: boolean;
  tipoCameraOTA: TipoCameraOTA;
  componenteXVariazione: ComponenteXVariazione;
  isSelected: boolean;
  toDelete: boolean;
}

export class TipoCameraOTACalendar extends Base {
  nome: string;
  guid: string;
  url: string;
  isClosed: boolean;
  tipoCameraOTA: TipoCameraOTA;
}

export class TipoCameraOTAUpgrade extends Base {
  dal: string;
  al: string;
  disponibiliMinime: number;
  durataMinimaSoggiorno: number;
  giorniAnticipoSoggiorno: number;
  tipoCameraOTA: TipoCameraOTA;
  tipoCameraOTAVendita: TipoCameraOTA;
}

export class AlbergoApiKeys extends BaseAlbergo {
  apiKey: string;
  authSecret: string;
  utente: string;
  password: string;
  passwordMask: string;
  cellulare: string;
  url: string;
  audienceId: string;
  dataCreazione: string;
  tipoApiKey: TipoApiKey;
  isAttivo: boolean;
  isTest: boolean;
  isInvioAutomatico: boolean;
  isAnonimizzaCliente: boolean;
  //statoMyForecast: StatoMyForecast;
  descrizione: string;
  ipApiKey: string;
  //tipoParametroMyForecast: TipoParametroRicerca;
  portaleXAlbergo: PortaleXAlbergo;
}

export class BackgroundWorker extends BaseAlbergo {
  descrizione: string;
  isAttivo: boolean;
  ultimaEsecuzione: string;
}

export class NotificaEmail extends Base {
  tipoNotificaEmail: TipoNotificaEmail;
  codiceOTAPrenotazione: string;
  codicePreventivo: string;
  dataUltimaModificaPrenotazione: string;
  dataInvio: string;
  emailTo: string;
  oggetto: string;
  portaleXAlbergo: PortaleXAlbergo;
  urlHtml: string;
  workFlow: string;
  utente: string;
}

export class Interesse extends BaseAlbergo {
  descrizione: string;
  colore: number;
  coloreHex: string;
}

export class MessaggioExtranet extends BaseAlbergo {
  messaggio: string;
  scadenza: string;
}

export class AccountMail extends BaseAlbergo {
  nome: string;
  password: string;
  passwordMask: string;
  passwordSmtp: string;
  passwordSmtpMask: string;
  serverSmtp: string;
  portaSmtp: number;
  timeoutSmtp: number;
  usernameSmtp: string;
  isAutenticazioneSmtp: boolean;
  serverImap: string;
  portaImap: number;
  isScaricaMailCrm: string;
  email: string;
  displayName: string;
  utente: string;
  isEnableSsl: boolean;
  sslProtocol: SslProtocols;
  secureSocketOption: SecureSocketOptions;
  isTest: boolean;
}

export class Sondaggio extends BaseAlbergo {
  uid: string;
  nome: string;
  isAttivo: boolean;
  codicePromozionale: CodicePromozione;
  isModelloPassepartout: boolean;
  sogliaPunteggio: number;
  template: Template;
  templateCliente: Template;
  ubicazioneIstat: UbicazioneIstat;
}

export class SondaggioXLingua extends Base {
  testoIniziale: string;
  testoFinalePunteggioBasso: string;
  testoFinalePunteggioAlto: string;
  lingua: Lingua;
  sondaggio: Sondaggio;
}

export class SondaggioDomanda extends Base {
  tipo: TipoDomandaSondaggio;
  isObbligatoria: boolean;
  ordinamento: number;
  sondaggio: Sondaggio;
}

export class SondaggioDomandaXLingua extends Base {
  titolo: string;
  valori: string;
  valoriArray: string[];
  lingua: Lingua;
  sondaggioDomanda: SondaggioDomanda;
}

export class SondaggioRisposta extends BaseAlbergo {
  data: string;
  risposta: string;
  punteggio: number;
  stato: StatoSondaggio;
  isNotificataAGestionale: boolean;
  sondaggio: Sondaggio;
  cliente: Cliente;
  prenotazione: Prenotazione;
  portaleXAlbergo: PortaleXAlbergo;
}

export class VariazionePrezzoXArticoloXTipoCamera extends Base {
  tipoCamera: TipoCamera;
  giornoSettimana: number;
  valoreStringa: string;
}

export class VariazionePrezzoXArticoloXTrattamento extends Base {
  tipoCamera: TipoCamera;
  trattamento: Trattamento;
  valoreStringa: string;
}

export class VariazionePrezzoXArticoloXDurata extends Base {
  tipoCamera: TipoCamera;
  giornoInizio: number;
  giornoFine: number;
  valoreStringa: string;
}

export class VariazionePrezzoXArticoloXComponente extends Base {
  tipoCamera: TipoCamera;
  trattamento: Trattamento;
  componenteXVariazione: ComponenteXVariazione;
  valoreStringa: string;
}

export class VariazionePrezzoXArticoloXTipoPasto extends Base {
  valore: number;
  tipoValore: TipoValore;
  tipoComponentePrenotazione: TipoComponentePrenotazione;
  tipoPasto: TipoPasto;
}

export class VariazionePrezzoXArticoloXComponenteXTipoCamera extends Base {
  tipoCamera: TipoCamera;
  trattamento: Trattamento;
  componente: Riduzione;
  valore: string;
  adulti: number;
  adultiPaganti: number;
}

export class VariazionePrezzoXArticoloXPersona extends Base {
  minAdulti: number;
  paxInizio: number;
  paxFine: number;
  tipoValore: TipoValore;
  valore: number;
  tipoCamera: TipoCamera;
  componente: Riduzione;
}

export class VariazionePrezzoXArticoloXPianoFamiglia extends Base {
  tipoCamera: TipoCamera;
  componenteXVariazione: ComponenteXVariazione;
  numeroAdulti: number;
  numeroBambini: number;
  numeroEnfant: number;
  quotePaganti: number;
}

export class VariazionePrezzoXArticoloXGiorniAnticipo extends Base {
  tipoCamera: TipoCamera;
  da: number;
  a: number;
  valoreStringa: string;
}

export class WebHooks extends BaseAlbergo {
  descrizione: string;
  tipo: TipoOperazioneWebHooks;
  url: string;
}

export class WorkFlow extends BaseAlbergo {
  descrizione: string;
  statoPreventivoIniziale: StatoPreventivo;
  statoPreventivoFinale: StatoPreventivo;
  template: Template;
  tag: TagCrm;
  isAttivo: boolean;
  colore: number;
  coloreHex: string;
  isManuale: boolean;
  isCaparra: boolean;
  isAggiungiPromemoria: boolean;
  isInviaEmailHotel: boolean;
  campoFiltroWorkFlow: CampoFiltroWorkFlow;
  condizioneCampoFiltroWorkFlow: CondizioneCampoFiltroWorkFlow;
  giorniCampoFiltroWorkFlow: number;
  tipoWorkFlow: TipoWorkFlow;
  isRifiutata: boolean;
  isConPreventivo: boolean;
  isCheckInOnlineEseguito: boolean;
  isCheckInOnlineEseguitoTuttiComponenti: boolean;
  tipoPrenotazione: TipoPrenotazione;
  importoPayMail: ImportoPayMail;
  orarioInizio: string;
  orarioFine: string;
  mercato: ParametroRicerca;
  canaleVendita: ParametroRicerca;
  politicaCancellazione: Cancellazione;
  ubicazioneIstat: UbicazioneIstat;
  tipoCamera: TipoCamera;
  trattamento: Trattamento;
  modalitaPagamento: ModalitaPagamento;
  modalitaPagamentoPayMail: ModalitaPagamento;
  isPrivacy: boolean;
  isNewsLetter: boolean;
  isCodiceTessera: boolean;
  isEmailCompilata: boolean;
  statoPrenotazioneWelcome: StatoPrenotazioneWelcome;
  codicePromozione: CodicePromozione;
  sondaggio: Sondaggio;
  linguaDefault: Lingua;
  dataInizioAutomatismo: string;
  dataFineAutomatismo: string;
  giorniSettimana: string;
  emailAggiuntiva: string;
  numeroCamereDisponibiliMinimeCreazionePreventivo: number;
  modalitaSelezioneTariffaCreazionePreventivo: ModalitaSelezioneTariffaWorkFlowCreazionePreventivo;
  isInviaPreventivo: boolean;
  modelloAutomatismo: ModelloAutomatismo;
  numeroNottiMinimeCreazionePreventivo: number;
  numeroNottiMassimeCreazionePreventivo: number;
  nazione: Nazione;
  tipiPrenotazione: string;
  oidModalitaPagamento: string;
  oidTipiCamera: string;
  oidTrattamenti: string;
  oidParametriMercato: string;
  oidParametriCanaleVendita: string;
  oidPoliticheCancellazione: string;
}

export class RoomingList extends BaseAlbergo {
  uid: string;
  password: string;
  codicePrenotazione: string;
  statoRoomingList: StatoRoomingList;
}

export class CausaleOperazione extends BaseAlbergo {
  descrizione: string;
  tipoCausaleOperazione: TipoCausaleOperazione;
  isAttiva: boolean;
  isAttivaMyPage: boolean;
  template: Template;
}

export class CausaleOperazioneXLingua extends Base {
  descrizione: string;
  lingua: Lingua;
  causaleOperazione: CausaleOperazione;
}

export class TipoCliente extends BaseAlbergo {
  nome: string;
  isAllarme: boolean;
  isNascondiImportiSelfCheckIn: boolean;
  oidArticoliUpSelling: string;
}

export class PrenotazioneCC extends Base {
  numero: string;
  numeroMasked: string;
  titolare: string;
  anno: number;
  mese: number;
  codiceOTAPrenotazione: string;
  dataScadenzaCCString: string;
  tipoCCString: string;
  tipoCartaCredito: number;
  email: string;
  token: string;
  portaleXAlbergo: PortaleXAlbergo;
}

export class Evento extends BaseAlbergo {
  dal: string;
  al: string;
  nome: string;
  descrizione: string;
  colore: number;
  coloreHex: string;
  urlImmagine: string;
}

export class EventoXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  evento: Evento;
}

export class PrenotazioneUpSelling extends Base {
  prezzo: number;
  upSelling: UpSelling;
  prenotazione: Prenotazione;
  tipoCamera: TipoCamera;
  statoUpSelling: StatoUpSelling;
}

export class TipoPagamento extends BaseAlbergo {
  descrizione: string;
  isAttivo: boolean;
}

export class LogAccesso extends Base {
  tipoErroreLogAccesso: TipoErroreLogAccesso;
  tipoLogAccesso: TipoLogAccesso;
  isObsoleto: boolean;
}

export class AlbergoApiKeysLog extends BaseAlbergo {
  operazione: string;
  dataPrimaRichiesta: string;
  dataUltimaRichiesta: string;
  numeroRichieste: number;
}

export class PianoTariffario extends BaseAlbergo {
  nome: string;
  isAttivo: boolean;
  giorniValidita: string;
}

export class DettaglioPianoTariffario extends Base {
  dal: string;
  al: string;
  sconto: number;
  durataMinimaSoggiorno: number;
  giorniAnticipoSoggiorno: number;
  politicaCancellazione: Cancellazione;
  pianoTariffario: PianoTariffario;
}

export class BookingRules extends BaseAlbergo {
  dal: string;
  al: string;
  nome: string;
  isAttiva: boolean;
  tipo: TipoWorkFlow;
  tipoPrenotazione: TipoPrenotazione;
  isChiudiDisponibilita: boolean;
  variazionePrezzo: number;
  mercato: ParametroRicerca;
  canaleVendita: ParametroRicerca;
  tipoCamera: TipoCamera;
  trattamento: Trattamento;
  fascia: Fascia;
}

export class Storico extends Base {
  data: string;
  numeroHotel: number;
  prenotazioniOTA: number;
  prenotazioniWEB: number;
  prenotazioniCRM: number;
  numeroRichieste: number;
  preventiviInviati: number;
  prenotazioniCancellate: number;
  numeroPrenotazioniOTA: number;
  numeroPrenotazioniWEB: number;
  numeroPrenotazioniCRM: number;
  numeroPreventiviInviati: number;
  numeroPrenotazioniCancellate: number;
  datiAnnoPrecedente: Storico;
}

export class PrenotazioneWS extends Base {
  arrivo: string;
  partenza: string;
  codiceOTA: string;
  indiceCameraOTA: number;
  isImportata: boolean;
  isModificataSulPortale: boolean;
  isCancellataSulPortale: boolean;
  isRecuperata: boolean;
  portaleXAlbergo: PortaleXAlbergo;
}

export class LogErrorePortale extends BaseAlbergo {
  data: string;
  tipoErroreLogPortale: TipoErroreLogPortale;
  nomePortale: string;
  errorePortale: string;
  isNotificataAGestionale: boolean;
  isEsaminata: boolean;
}

export class AlbergoMasterPagina extends Base {
  nome: string;
  url: string;
  isModale: boolean;
  tipo: TipoPaginaDms;
  albergoMaster: AlbergoMaster;
}

export class AlbergoMasterPaginaXLingua extends Base {
  nome: string;
  testo: string;
  design: string;
  albergoMasterPagina: AlbergoMasterPagina;
  lingua: Lingua;
}

export class SorgenteRichiesta extends BaseAlbergo {
  campo: string;
  valore: string;
  mercato: ParametroRicerca;
  canaleVendita: ParametroRicerca;
}

export class MySelfPage extends BaseAlbergo {
  nome: string;
  colore: number;
  coloreHex: string;
  isHome: boolean;
  isAttiva: boolean;
  tipoPaginaMySelf: TipoPaginaMySelf;
  isUsaEditor: boolean;
  url: string;
  icona: string;
  urlImmagine: string;
  ubicazioneIstat: UbicazioneIstat;
}

export class MySelfPageXLingua extends Base {
  titolo: string;
  testo: string;
  design: string;
  lingua: Lingua;
  mySelfPage: MySelfPage;
}

export class Piatto extends BaseAlbergo {
  nome: string;
  urlImmagine: string;
  quantitaMassimaXPersona: number;
  categoriaPiatto: CategoriaPiatto;
  allergeni: string;
}

export class PiattoXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  piatto: Piatto;
}

export class CategoriaPiatto extends BaseAlbergo {
  descrizione: string;
  quantitaMassimaXPersona: number;
}

export class CategoriaPiattoXLingua extends Base {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  categoriaPiatto: CategoriaPiatto;
}

export class Menu extends BaseAlbergo {
  descrizione: string;
  colore: number;
  coloreHex: string;
}

export class MenuXLingua {
  nome: string;
  descrizione: string;
  lingua: Lingua;
  menu: Menu;
}

export class PiattoXMenu extends Base {
  ordinamento: number;
  tipoPasto: TipoPasto;
  menu: Menu;
  piatto: Piatto;
}

export class UbicazioneIstatMenu extends BaseAlbergo {
  data: string;
  ubicazioneIstat: UbicazioneIstat;
  menu: Menu;
}

export class AlbergoCrs extends BaseAlbergo {
  descrizione: string;
  utente: string;
  password: string;
  server: string;
  porta: number;
  azienda: string;
  url: string;
  isAttivo: boolean;
  oidAlbergoWeb: number;
  isRicezionePrenotazioni: boolean;
  isInvioPrenotazioni: boolean;
  colore: string;
  templateRicezionePrenotazioni: Template;
}

export class PreventivoTimeLine extends Base {
  data: string;
  statoIniziale: StatoPreventivo;
  statoFinale: StatoPreventivo;
  operazione: string;
  utente: string;
  isHotel: boolean;
  preventivo: Preventivo;
}

export class PrenotazioneConteggioPiatti extends Base {
  data: string;
  tipoPasto: TipoPasto;
  quantita: number;
  note: string;
  piatto: Piatto;
  prenotazione: Prenotazione;
}

export class ChangeLog extends Base {
  versione: string;
  data: string;
  categoria: string;
  descrizione: string;
  isAttivo: boolean;
}

export class PrenotazioneLogBilanciamento extends Base {
  data: string;
  portale: string;
  oidPrenotazione: number;
  codiceOTA: string;
  tariffaOTA: string;
  tipoCameraOTA: string;
  isDeleting: boolean;
  disponibili: number;
  tipoBilanciamento: TipoBilanciamentoInterno;
  statoPortaleXAlbergo: StatoPortaleXAlbergo;
  isStatoPortaleXAlbergoBloccato: boolean;
}

export class StoricoPrenotazioneWS extends Base {
  arrivo: string;
  partenza: string;
  xmlPrenotazione: string;
  codiceOTA: string;
  indiceCameraOTA: number;
  nominativo: string;
  pax: number;
  importo: number;
  urlWebServiceOTA: string;
  versioneHotel: string;
  isEsaminata: boolean;
  portaleXAlbergo: PortaleXAlbergo;
}

export class TariffaOTAXPortale extends Base {
  codice: string;
  descrizione: string;
  portale: Portale;
}

export class PortaleParametri extends Base {
  chiave: string;
  valore: TipoParametroPortale;
  valore_old: TipoParametroPortale;
  portale: Portale;
}

export class VariazioneTassaSoggiornoXTrattamento extends Base {
  etaMinima: number;
  etaMassima: number;
  tipoEsenzione: number;
  valore: number;
  trattamento: Trattamento;
  ubicazioneIstat: UbicazioneIstat;
}

export class VariazioneTassaSoggiornoXUbicazioneIstat extends Base {
  dal: string;
  al: string;
  valore: number;
  trattamento: Trattamento;
  ubicazioneIstat: UbicazioneIstat;
}

export class PortaleXAlbergoVariazioni extends Base {
  dal: string;
  al: string;
  giorniValidita: string;
  giorniValiditaSelected: GiornoSettimana[];
  durataMinimaSoggiorno: number;
  variazioniDisponibili: number;
  tipoValoreVariazione: TipoValore;
  valoreVariazione: number;
  isApplicaVariazionePrezzoMaster: boolean;
  portaleXAlbergoMaster: PortaleXAlbergo;
  portaleXAlbergo: PortaleXAlbergo;
  tipoCameraOTA: TipoCameraOTA;
  tariffaOTA: TariffaOTA;
}

export class Risorsa extends BaseAlbergo {
  nome: string;
  descrizione: string;
  note: string;
  dimensione: string;
  oidServizi: string;
  tipoCamera: TipoCamera;
  servizi: BookingSolutionServiceRS[];
  immagini: string[];
}

export class RisorsaXLingua extends Base {
  nome: string;
  descrizione: string;
  note: string;
  lingua: Lingua;
  risorsa: Risorsa;
}

export class RisorsaImmagini extends Base {
  ordinamento: number;
  urlImmagine: string;
  base64String: string;
  risorsa: Risorsa;
}

export class SmtpServer extends Base {
  nome: string;
  server: string;
  utente: string;
  password: string;
  email: string;
  porta: number;
  isEnableSsl: boolean;
  isAutenticazione: boolean;
  isReturnPathAttivo: boolean;
  timeout: number;
}

export class PortaleXAlbergoServiziOTA extends Base {
  codice: string;
  articolo: Articolo;
  portaleXAlbergo: PortaleXAlbergo;
}

export class PortaleXAlbergoCancellazioniOTA extends Base {
  codice: string;
  cancellazione: Cancellazione;
  portaleXAlbergo: PortaleXAlbergo;
}

export class GiorniChiusura extends BaseAlbergo {
  dal: string;
  al: string;
  note: string;
  ubicazioneIstat: UbicazioneIstat;
}

export class PortaleXAlbergoFiltri extends Base {
  nome: string;
  filtro: FiltroTipoCameraTariffe[];
  isVisualizzaMobile: boolean;
  isVisualizzaPlanning: boolean;
  portaleXAlbergo: PortaleXAlbergo;
}

export class QuadroGrafico extends Base {
  nome: string;
  urlImmagine: string;
  urlImmagineRisorsaLibera: string;
  urlImmagineRisorsaOccupata: string;
  urlImmagineRisorsa: string;
  base64Immagine: string;
  base64ImmagineRisorsaLibera: string;
  base64ImmagineRisorsaOccupata: string;
  base64ImmagineRisorsa: string;
}